import React, { useEffect, useState } from 'react';
import style from '../../../../assets/styles/viewTaskDetail.module.css';
import AuthLayout from '../../../../layout/AuthLayout';
import RightPanelTopMenu from '../../common/RightPanelTopMenu';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import testEditIcon from '../../../../assets/images/editTestIcon.svg';
import reworkArrowIcon from '../../../../assets/images/reworkBtn.svg';
import reviewArrowIcon from '../../../../assets/images/greyarrow.svg';
import approveArrowIcon from '../../../../assets/images/greenarrow.svg';
import Pagination from '../../common/Pagination';
import CommentSection from './CommentSection';
import RecentActivity from './RecentActivity';
import {
  CreateQuestionAction,
  GetTaskViewDetails,
  createActivity,
  viewfetchActivities,
  flushTaskViewData,
  recentActivity,
} from '../../../../redux/action';
import { CallWithAuth } from '../../../../action/apiActions';
import { CREATE_NEW_TASK, POST_INITIALIZING_QUESTION_CREATION } from '../../../../action/apiPath';
import { useToast } from '../../common/Toast';
import { openPreviewModal, closePreviewModal } from '../../../../component/atoms/Modal/modalHandlers';
import PreviewModal from '../../../atoms/Modal/PreviewModal';
import { closeModalHelper } from '../../../atoms/Modal/duplicateHelper';
import { editQuestionHandler } from '../../../../component/atoms/Modal/editHandlers';
import QuestionListModal from '../../../atoms/Modal/QuestionListModal';
import LockModal from '../../../atoms/Modal/LockModel';
import { handleConfirmDuplicate } from '../../../atoms/Modal/duplicateInPreviewHelper';
import unlinkIcon from '../../../../assets/images/unlink.svg';

const TaskViewDetails = () => {
  const { id } = useParams();
  const taskId = id;
  const location = useLocation();
  const navigate = useNavigate();
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(0);
  const dispatch = useDispatch();
  const limit = 10;
  const userInfo = JSON.parse(localStorage.getItem('userInfo') ?? '{}');
  const userId = userInfo.id;
  const organizationId = localStorage.getItem('selectedOrgId');
  const [totalCount, setTotalCount] = useState(0);
  const [isPreviewopen, setIsPreviewopen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedQuestion, setSelectedQuestion] = useState('');
  const [modalMedium, setModalMedium] = useState(false);
  const [questionAccess, setQuestionAccess] = useState({});
  const [modalData, setModalData] = useState<{ questionId: number; questionBankId: number }>();
  const [isDuplicatePreview, setIsDuplicatePreview] = useState(false); // State to store dataToPass
  const { taskViewDetailsData } = useSelector((state: any) => state.GetAllData);
  const [questionBankId] = useState(4);
  const [questionItem, setQuestionItem] = useState({});
  const [modalModalData] = useState({
    title: 'This Question is Linked to Existing Tests',
    description:
      'The question you are about to edit has been used in one or more tests. Please be sure to click the ‘Update Exam’ button to update the changes across all tests that include this question.',
    cancelButton: 'Cancel',
    saveButton: 'Continue',
    substitle: 'Are you sure you want to proceed with editing this question?',
  });
  const [taskData, setTaskData] = useState<{
    task_id: string;
    task_status: { id: number; status: string };
    task_type: { id: number; type: string };
    task_detail: string;
    assignee: string;
    approver: string[];
    task_permission: string;
    created_at: string;
    end_date: string;
    question_bank: string;
    test_data: { test_id: number; [key: string]: any }[];
    question_data: any[];
    task_item_count: number;
    totalQuestionCount: number;
    question_bank_id: number;
  }>({
    task_id: '',
    task_status: { id: 0, status: '' },
    task_type: { id: 0, type: '' },
    task_detail: '',
    assignee: '',
    approver: [],
    task_permission: '',
    created_at: '',
    end_date: '',
    question_bank: '',
    test_data: [],
    question_data: [],
    task_item_count: 0,
    totalQuestionCount: 0,
    question_bank_id: 0,
  });

  useEffect(() => {
    if (taskViewDetailsData) {
      // Transform data based on task type
      let transformedQuestionData: any[] = [];
      let totalQuestionCount = 0;
      // Handle different data structures for question_data
      if (taskViewDetailsData.question_data) {
        setTotalCount(taskViewDetailsData.question_data.count);
        if (Array.isArray(taskViewDetailsData.question_data)) {
          // For Question Edit type
          transformedQuestionData = taskViewDetailsData.question_data;
        } else {
          // For Question Authoring type with pagination
          transformedQuestionData = taskViewDetailsData.question_data.results || [];
          totalQuestionCount = taskViewDetailsData.question_data.count || 0;
        }
      }

      // Transform test_data
      const transformedTestData = (taskViewDetailsData.test_data || []).map((test: any) => ({
        ...test,
        free_tags: test.free_tags ? test.free_tags.map((tag: any) => tag.name) : [],
        author: typeof test.author === 'number' ? `Author ${test.author}` : test.author,
      }));

      // Clean up approver array to remove empty strings
      const cleanedApprovers = (taskViewDetailsData.approver || []).filter(
        (approver: string) => approver.trim() !== ''
      );

      // Update the taskData state with the transformed data
      setTaskData({
        ...taskViewDetailsData,
        approver: cleanedApprovers,
        test_data: transformedTestData,
        question_data: transformedQuestionData,
        totalQuestionCount: totalQuestionCount,
      });
    }
  }, [taskViewDetailsData]);

  const refreshActivity = () => {
    dispatch(viewfetchActivities(organizationId, taskId, 15, 1));
    dispatch(recentActivity(organizationId));
  };
  const [isLoadingApi, setIsLoadingApi] = useState(false);
  // Function to handle status changes
  const handleStatusChange = async (newStatusId: number, newStatus: string) => {
    const body = {
      status: newStatus,
    };

    const createactivityPayload = {
      task_activity_status: newStatusId,
      created_at: new Date().toISOString(),
    };
    setIsLoadingApi(true);
    try {
      const url = `${CREATE_NEW_TASK}${id}/review-task/${organizationId}/`;
      const response = await CallWithAuth('PATCH', url, body);

      if (response.status && response.res && response.res.status === 200) {
        toast?.remove('all');
        toast?.add(response.res?.data?.message, 'success');
        dispatch(GetTaskViewDetails(id, organizationId, limit, currentPage, toast));
        dispatch(
          createActivity(
            id,
            userId,
            createactivityPayload.task_activity_status,
            createactivityPayload.created_at,
            toast,
            refreshActivity
          )
        );
      } else {
        toast?.remove('all');
        toast?.add(response.res?.data?.error, 'error');
      }
    } catch (error) {
      toast?.remove('all');
      toast?.add('An error occured', 'error');
    }
    setIsLoadingApi(false);
  };

  // unlink from task
  const unlinkItem = async (itemId: any) => {
    const body = {
      item_id: itemId,
      item_type: taskData.task_type.id,
    };
    // const createactivityPayload = {
    //   created_at: new Date().toISOString(),
    // };
    try {
      const url = `${CREATE_NEW_TASK}${id}/remove-item-task/${organizationId}/`;
      const response = await CallWithAuth('POST', url, body);

      if (response.status && response.res && response.res.status === 200) {
        toast?.remove('all');
        toast?.add(response.res?.data?.message, 'success');
        dispatch(GetTaskViewDetails(id, organizationId, limit, currentPage, toast));
        // dispatch(
        //   createActivity(
        //     id,
        //     userId,
        //     1,
        //     createactivityPayload.created_at,
        //     toast,
        //     refreshActivity
        //   )
        // );
      } else {
        toast?.remove('all');
        toast?.add(response.res?.data?.error, 'error');
      }
    } catch (error) {
      toast?.remove('all');
      toast?.add('An error occured', 'error');
    }
  };

  useEffect(() => {
    // This effect runs when the component mounts or when the URL/location changes

    // Reset the component state
    setTaskData({
      task_id: '',
      task_status: { id: 0, status: '' },
      task_type: { id: 0, type: '' },
      task_detail: '',
      assignee: '',
      approver: [],
      task_permission: '',
      created_at: '',
      end_date: '',
      question_bank: '',
      test_data: [],
      question_data: [],
      task_item_count: 0,
      totalQuestionCount: 0,
      question_bank_id: 0,
    });

    // Clear Redux store data
    dispatch(flushTaskViewData());

    if (id && organizationId) {
      dispatch(GetTaskViewDetails(id, organizationId, limit, currentPage, toast));
    }
  }, [id, location.pathname, dispatch, currentPage, offset, organizationId]);

  const handleBackbutton = () => {
    navigate('/task-management');
    dispatch(flushTaskViewData());
  };

  // Function to handle opening the preview modal

  useEffect(() => {
    const Permission = JSON.parse(sessionStorage.getItem('permissionForQuestions') ?? '{}');
    const newQuestionAccess = Permission?.question_bank_management?.filter(
      (item: any) => item.id === taskData.question_bank_id
    )[0];
    if (Permission && newQuestionAccess && taskData?.task_permission !== 'Approver') {
      sessionStorage.setItem('questionAccess', JSON.stringify(newQuestionAccess));
      setQuestionAccess(newQuestionAccess);
    } else {
      setQuestionAccess({});
      const payload = { draft: false, edit: false, review: false, view: false, id: questionBankId };
      sessionStorage.setItem('questionAccess', JSON.stringify(payload));
    }
  }, [taskData.question_bank_id]);

  const onConfirmDuplicate = (questionBankId: number, questionId: number) => {
    const setactionId = null;
    const questionCategory = null;
    const QuestionListing = () => Promise.resolve(true);
    const MyQuestionListing = () => Promise.resolve(true);
    handleConfirmDuplicate(
      organizationId,
      questionBankId,
      questionId,
      setIsModalOpen,
      setIsPreviewopen,
      setIsDuplicatePreview,
      setactionId,
      toast,
      questionCategory,
      QuestionListing,
      MyQuestionListing
    );
  };
  const handleOpenModal = (items: any) => {
    openPreviewModal(items, setSelectedQuestion, setIsPreviewopen);
  };
  const handleCloseModal = () => {
    closePreviewModal(setIsPreviewopen, setIsDuplicatePreview, setIsModalOpen);
  };

  const handleEdit = async (items: any) => {
    const updatedItems = { ...items, task_label: id };
    await editQuestionHandler(updatedItems, setIsPreviewopen, openModalMedium, setQuestionItem, navigate);
  };

  const openModalMedium = () => {
    setModalMedium(true);
  };
  const closeModalMedium = () => {
    setModalMedium(false);
  };
  const closeModal = () => {
    closeModalHelper(setIsModalOpen, setModalData, setIsDuplicatePreview);
  };

  const redirectToTestPaper = () => {
    navigate('/test-papers-management/add', {
      state: { testAuthoringTaskId: id },
    });
  };

  //add question for question authoring
  const initialQuestionCreation = async () => {
    const payload = {
      org_id: organizationId,
    };
    const initializeID = await CallWithAuth('POST', POST_INITIALIZING_QUESTION_CREATION, payload);
    if (initializeID?.status && typeof initializeID?.res?.data?.id === 'number' && taskData.question_bank_id) {
      dispatch(CreateQuestionAction(taskData.question_bank_id, initializeID?.res.data.id));
      localStorage.setItem('questionDraftId', initializeID?.res.data.id.toString());
    }
  };
  const redirectToQuestionCreation = async () => {
    initialQuestionCreation();
    navigate('/create-question', {
      state: { queTaskId: id, selectedQueBankId: questionBankId },
    });
  };
  return (
    <AuthLayout>
      <RightPanelTopMenu setQuestionBankId={null} title="Task Management" />
      <div className={style.TaskViewDetail_topTable} style={{ display: 'flex' }}>
        <div className={style.TaskViewDetail_section}>
          <button
            className={style.buttonStyle}
            onClick={() => {
              handleBackbutton();
            }}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M15.5488 19.422L9.02883 12.902C8.25883 12.132 8.25883 10.872 9.02883 10.102L15.5488 3.58203"
                stroke="#212529"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <span className={style.backButton}>Back</span>
          </button>

          <div className={style.taskContainer}>
            <div className={style.taskHeader}>
              <div className={style.firstDiv}>
                <span className={style.taskIdWrap}>
                  Task ID <span className={style.taskId}>{id}</span>
                </span>
                <span className={style.status} data-status={taskData?.task_status?.status}>
                  {taskData?.task_status?.status}
                </span>
              </div>
              <div className={style.secondDiv}>
                {taskData.task_status.id === 2 && (
                  <button
                    className={style.moveToReviewBtn}
                    onClick={() => handleStatusChange(3, 'In-Review')}
                    title={
                      taskData.task_type.id === 1 && taskData.task_item_count !== taskData.totalQuestionCount
                        ? 'Add question to meet the limit'
                        : ''
                    }
                    disabled={
                      isLoadingApi || taskData.task_type.id === 1
                        ? taskData.task_item_count !== taskData.totalQuestionCount
                        : false
                    }
                  >
                    Move to Review <img src={reviewArrowIcon} alt="editIcon" className={style.reworkBtn} />
                  </button>
                )}
                {taskData.task_status.id === 3 && (
                  <>
                    <button
                      disabled={isLoadingApi}
                      className={style.needsReworkBtn}
                      onClick={() => handleStatusChange(1, 'To-Do')}
                    >
                      Needs Rework <img src={reworkArrowIcon} alt="editIcon" className={style.reworkBtn} />
                    </button>
                    <button
                      disabled={isLoadingApi}
                      className={style.moveToApprovedBtn}
                      onClick={() => handleStatusChange(4, 'Approved')}
                    >
                      Move to Approved <img src={approveArrowIcon} alt="editIcon" className={style.reworkBtn} />
                    </button>
                  </>
                )}
                {taskData.task_status.id === 4 && (
                  <span className={style.approvedBtnWrap}>
                    Approved By: <span className={style.apprverName}>{taskData.approver[0]}</span>
                  </span>
                )}
                {taskData.task_status.id !== 3 && taskData.task_status.id !== 4 && taskData.question_bank_id > 0 && (
                  <button className={style.EditIconWrap} onClick={() => navigate(`/task-management/edit/${id}`)}>
                    <img src={testEditIcon} alt="editIcon" className={style.editIcon} />
                  </button>
                )}
              </div>
            </div>

            <div className={style.taskInfo}>
              <div className={style.taskAssignee}>
                <span>Assignee</span>
                <br />
                <div className={style.AssigneeName}>{taskData.assignee}</div>
              </div>
              <div className={style.taskApprover}>
                <span>Approver(s)</span>
                <br />
                <div className={style.taskApproverWrap}>
                  {taskData.approver.map((approver, index) => (
                    <span key={index + 1} className={style.taskApproverName}>
                      {approver}
                    </span>
                  ))}
                </div>
              </div>
              <div className={style.taskCreatedOn}>
                <span>Created on</span>
                <br />
                <div className={style.CreatedOnDate}>{taskData.created_at}</div>
              </div>
              <div className={style.taskEndDate}>
                <span>End date</span>
                <br />
                <div className={style.EndDate}>{taskData.end_date}</div>
              </div>
              <div className={style.taskQuestionBank} style={{ borderRight: 'none' }}>
                <span>Question Bank</span>
                <br />
                <div className={style.QuestionBankName}>{taskData.question_bank}</div>
              </div>
            </div>

            <div className={style.taskDetailsWrap}>
              <div className={style.TaskDetailHeader}>
                <div className={style.taskDetailText}>Task details</div>
                <span className={style.taskType}>
                  Type: <span>{taskData.task_type.type}</span>
                </span>
              </div>
              <p>{taskData.task_detail}</p>
            </div>
          </div>

          {taskData.task_status.id === 1 &&
            taskData.task_type.id === 1 &&
            taskData.question_data.length === 0 &&
            (taskData.task_permission === 'Assignee' || taskData.task_permission === 'Both') && (
              <div className={style.questionsRuleContainer}>
                <h2 className={style.noQuestionLabel}>No Questions Added!</h2>
                <p className={style.description}>Please click “Add Questions” button to proceed.</p>
                <button className={`${style.addNewQuestionButton}`} onClick={() => redirectToQuestionCreation()}>
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.16797 10H18.168"
                      stroke="#00ABFB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.168 18V2"
                      stroke="#00ABFB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span> Add Questions</span>
                </button>
              </div>
            )}
          {taskData.task_status.id === 1 &&
            taskData.task_type.id === 2 &&
            taskData.test_data.length === 0 &&
            (taskData.task_permission === 'Assignee' || taskData.task_permission === 'Both') && (
              <div className={style.questionsRuleContainer}>
                <h2 className={style.noQuestionLabel}>No Tests Added!</h2>
                <p className={style.description}>Please click “Add Test” button to proceed.</p>
                <button
                  className={`${style.addNewQuestionButton}`}
                  onClick={redirectToTestPaper}
                  // style={{ visibility: isView ? 'hidden' : 'visible' }}
                >
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="M2.16797 10H18.168"
                      stroke="#00ABFB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M10.168 18V2"
                      stroke="#00ABFB"
                      strokeWidth="3"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                  <span> Add Test</span>
                </button>
              </div>
            )}

          {/* Render Test Papers section only for Test Authoring type */}
          {taskData.task_type.id === 2 && taskData.test_data.length > 0 && (
            <div className={style.TaskViewDetail_testList}>
              <div className={style.testListWrap}>
                <div className={style.testListHeader}>
                  <div className={style.questionIdWrap} style={{ width: '50%' }}>
                    <span>Test List</span>
                  </div>
                  {taskData.task_status.id === 2 && (
                    <div className={style.unlinkButtonWrap} style={{ width: '50%' }}>
                      <button
                        className={`${style.unlinkButton}`}
                        onClick={() => unlinkItem(taskData?.test_data[0]?.test_id)}
                      >
                        <img src={unlinkIcon} alt="unlink" />
                        <div> Remove From Task</div>
                      </button>
                    </div>
                  )}
                </div>
                <div className={style.testListingTable}>
                  <table>
                    <thead>
                      <tr>
                        <th className={` ${style.first}`}>
                          <span>ID</span>
                        </th>
                        <th className={` ${style.second}`}>
                          <span>Test Name</span>
                        </th>
                        <th className={` ${style.third}`}>
                          <span>Player Type</span>
                        </th>
                        <th className={` ${style.fourth}`}>
                          <span>Test Type</span>
                        </th>
                        <th className={` ${style.fifth}`}>
                          <span>Question Bank</span>
                        </th>
                        <th className={` ${style.sixth}`}>
                          <span>Created On</span>
                        </th>
                        <th className={` ${style.seventh}`}>
                          <span>Author</span>
                        </th>
                        <th className={` ${style.eighth}`}>
                          <span>Academic Year</span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {taskData.test_data.map((test: any, index: number) => (
                        <tr key={index + 1}>
                          <td>
                            <div className={style.testId}>
                              <button
                                style={{ background: 'none', border: 'none', fontSize: '12px' }}
                                onClick={() => navigate(`/test-papers-management/details/${test.test_id}`)}
                              >
                                <u
                                  style={{
                                    fontWeight: 500,
                                    color: '#00abfb',
                                    cursor: 'pointer',
                                    paddingLeft: '6px',
                                  }}
                                >
                                  {test.test_id}
                                </u>
                              </button>
                            </div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px', paddingTop: '10px' }}>
                              <span>{test.test_name}</span>
                              {test.free_tags.length > 0 && (
                                <span
                                  style={{
                                    display: 'flex',
                                    gap: '5px',
                                    width: 'fit-content',
                                    flexWrap: 'wrap',
                                  }}
                                  className={style.description_detail}
                                >
                                  {test.free_tags.map((tag: any, i: any) => (
                                    <button key={i + 1} className={style.general_button} style={{ cursor: 'auto' }}>
                                      {typeof tag === 'string' ? tag : tag.name}
                                    </button>
                                  ))}
                                </span>
                              )}
                            </div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>
                              <span
                                style={{
                                  display: 'flex',
                                  gap: '5px',
                                  width: 'fit-content',
                                  flexWrap: 'wrap',
                                }}
                                className={style.description_detail}
                              >
                                <button className={style.template_button} style={{ cursor: 'auto' }}>
                                  {test.player_type}
                                </button>
                              </span>
                            </div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>{test.test_type}</div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>{test.question_banks.join(', ')}</div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>{test.created_on}</div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>{test.author}</div>
                          </td>
                          <td>
                            <div style={{ paddingLeft: '10px' }}>{test.academic_year}</div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}

          {/* Render Question List section for Question Authoring type */}
          {taskData.task_type.id === 1 &&
            Array.isArray(taskData.question_data) &&
            taskData.question_data.length > 0 && (
              <div className={style.TaskViewDetail_QuestionList}>
                <div className={style.questionListHeader}>
                  <span>Question List</span>
                  {taskData.task_item_count > taskData.totalQuestionCount &&
                    (taskData.task_permission === 'Assignee' || taskData.task_permission === 'Both') && (
                      <div>
                        <button className={`${style.addQuestionButton}`} onClick={() => redirectToQuestionCreation()}>
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M2.16797 10H18.168"
                              stroke="#00ABFB"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                            <path
                              d="M10.168 18V2"
                              stroke="#00ABFB"
                              strokeWidth="3"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span> Add Question</span>
                        </button>
                      </div>
                    )}
                </div>
                {taskData.question_data.map((question: any, index: number) => (
                  <div key={index + 1} className={style.questionListingCard}>
                    <div className={`${style.cardHeader} ${style.unlinkHeader}`}>
                      <div className={style.questionIdWrap} style={{ width: '50%', marginBottom: '10px' }}>
                        <span className={style.questionNumber}>ID:</span>
                        <button
                          className={style.questionId}
                          onClick={() => {
                            handleOpenModal(question.question_id);
                          }}
                        >
                          {question.question_id}
                        </button>
                      </div>
                      {taskData.task_status.id === 2 && (
                        <div className={style.unlinkButtonWrap} style={{ width: '50%' }}>
                          <button className={`${style.unlinkButton}`} onClick={() => unlinkItem(question.question_id)}>
                            <img src={unlinkIcon} alt="unlink" />
                            <span> Remove From Task</span>
                          </button>
                        </div>
                      )}
                    </div>
                    <div className={style.cardBody}>
                      <div className={style.tags}>
                        <span className={style.primaryTag}>{question.subject_tags}</span>
                      </div>
                      <div className={style.questionIdentifier}>
                        <span className={style.shortIdentifier}>{question.question_short_identifier}</span>
                      </div>
                      <div className={`${style.general_tag}`}>
                        {question?.free_tags.length > 0 &&
                          question?.free_tags?.map((tag: any, i: any) => (
                            <button key={i + 1} className={`${style.general_button}`}>
                              {tag?.name}
                            </button>
                          ))}
                      </div>
                      <p className={style.questionListInfo}>
                        <div className={style.AuthorDataWrap}>
                          <span className={style.labelTitle}>Author:</span>
                          <div className={style.labelText}>{question.author_by}</div>
                        </div>
                        <div className={style.AcademicYearDataWrap}>
                          <span className={style.labelTitle}>Academic Year:</span>
                          <div className={style.labelText}>{question.academic_year}</div>
                        </div>
                        <div className={style.CreatedOnDataWrap}>
                          <span className={style.labelTitle}>Created On:</span>
                          <div className={style.labelText}>{question.created_on}</div>
                        </div>
                        <div className={style.TypeDataWrap}>
                          <span className={style.labelTitle}>Type:</span>
                          <div className={style.labelText}>{question.question_type}</div>
                        </div>
                        <div className={style.LODDataWrap}>
                          <span className={style.labelTitle}>LOD:</span>
                          <div className={style.labelText}>{question.lod}</div>
                        </div>
                      </p>
                    </div>
                  </div>
                ))}
                {totalCount > 10 && (
                  <div className={style.taskDetailQuestionListPagination}>
                    <Pagination
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                      limit={limit}
                      totalCount={totalCount}
                      offset={offset}
                      setOffset={setOffset}
                    />
                  </div>
                )}
              </div>
            )}

          {/* Render Question Edit List section for Question Edit type */}
          {taskData.task_type.id === 3 &&
            Array.isArray(taskData.question_data) &&
            taskData.question_data.length > 0 && (
              <div className={style.TaskViewDetail_QuestionEditList}>
                <div className={style.questionListHeader}>
                  <span>Added Question to Edit</span>
                </div>
                {taskData.question_data.map((question: any, index: any) => (
                  <div key={index + 1} className={style.questionListingCard}>
                    <div className={style.cardHeader}>
                      <div className={style.questionIdWrap} style={{ marginBottom: '15px' }}>
                        <span className={style.questionNumber}>ID:</span>
                        <button
                          className={style.questionId}
                          onClick={() => {
                            handleOpenModal(question.question_id);
                          }}
                        >
                          {question.question_id}
                        </button>
                      </div>
                    </div>
                    <div className={style.cardBody}>
                      <div className={style.tags}>
                        <span className={style.primaryTag}>{question.subject_tags}</span>
                      </div>
                      <div className={style.questionIdentifier}>
                        <span className={style.shortIdentifier}>{question.question_short_identifier}</span>
                      </div>
                      <div className={`${style.general_tag}`}>
                        {question?.free_tags.length > 0 &&
                          question.free_tags.map((tag: any, i: any) => (
                            <button key={i + 1} className={`${style.general_button}`}>
                              {tag?.name}
                            </button>
                          ))}
                      </div>
                      <p className={style.questionListInfo}>
                        <div className={style.AuthorDataWrap}>
                          <span className={style.labelTitle}>Author:</span>
                          <div className={style.labelText}>{question.author_by}</div>
                        </div>
                        <div className={style.AcademicYearDataWrap}>
                          <span className={style.labelTitle}>Academic Year:</span>
                          <div className={style.labelText}>{question.academic_year}</div>
                        </div>
                        <div className={style.CreatedOnDataWrap}>
                          <span className={style.labelTitle}>Created On:</span>
                          <div className={style.labelText}>{question.created_on}</div>
                        </div>
                        <div className={style.TypeDataWrap}>
                          <span className={style.labelTitle}>Type:</span>
                          <div className={style.labelText}>{question.question_type}</div>
                        </div>
                        <div className={style.LODDataWrap}>
                          <span className={style.labelTitle}>LOD:</span>
                          <div className={style.labelText}>{question.lod}</div>
                        </div>
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}

          {isPreviewopen && (
            <PreviewModal
              onEdit={handleEdit}
              questionAccess={questionAccess}
              selectedQuestion={selectedQuestion}
              isOpen={isPreviewopen}
              onClose={handleCloseModal}
              setIsDuplicateModalOpen={setIsModalOpen}
              setModalData={setModalData}
              modalData={modalData}
              setIsDuplicatePreview={setIsDuplicatePreview}
              iframeSrc="/question-content-url"
            />
          )}
          {isModalOpen && (
            <QuestionListModal
              isOpen={isModalOpen}
              onClose={closeModal}
              onConfirm={onConfirmDuplicate}
              data={modalData} // Pass modalData to the modal
              isDuplicatePreview={isDuplicatePreview}
            />
          )}
          {modalMedium && (
            <div className={` ${style.taskQuestionLockModal}`}>
              <LockModal
                modalData={modalModalData}
                forwardButton={() => navigate('/edit-question', { state: questionItem })}
                modalMedium={modalMedium}
                closeModalMedium={closeModalMedium}
              />
            </div>
          )}
          <CommentSection taskId={id ? Number(id) : undefined} />
        </div>
        <RecentActivity />
      </div>
    </AuthLayout>
  );
};

export default TaskViewDetails;
